import { render, staticRenderFns } from "./BetStats.vue?vue&type=template&id=095ecf40"
import script from "./BetStats.vue?vue&type=script&lang=ts"
export * from "./BetStats.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports